import config from "@lib/config";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { EndpointBuilder } from '@reduxjs/toolkit/query';

export const homeRegApi = createApi({
  reducerPath: 'homeRegApi',
  baseQuery: fetchBaseQuery({
    baseUrl: config.REG_API_ENDPOINT,
    prepareHeaders: async (headers: Headers) => {
      headers.set('x-api-key', config.REG_API_KEY);
      headers.set('Access-Control-Allow-Origin', config.DASHBOARD_URL);
      headers.set('Access-Control-Allow-Methods', 'GET, POST, OPTIONS');
      headers.set('Access-Control-Allow-Headers', 'Content-Type, x-api-key');
      return headers;
    }
  }),
  endpoints: (builder: EndpointBuilder) => {
    return {
      /** Get registration status for given properties */
      registrationStatus: builder.query<boolean, { propertyId: string, token: string }>({
        query: ({ propertyId, token }: { propertyId: string, token: string }) => ({
          url: `/registration-status/${propertyId}`,
          params: { token },
        })
      }),

    };
  }
});


export const {
  useRegistrationStatusQuery
 } = homeRegApi;
